import React, { useState, useEffect, useMemo } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { Dialog, DialogContent, DialogTrigger } from '@/customercenter-ui/ui/dialog';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { getFAQLink } from '@/helpers/utils/siteUtils';
import {
  getContentByTitle,
  getMostSpecificMatch,
} from '../../../../../../customercenter-ui/components/product/details/helpers/utils/productDataUtils';
interface LearnMoreProps {
  department?: string;
  classValue?: string;
  subClassValue?: string;
}

const LearnMore: React.FC<LearnMoreProps> = ({ department, classValue, subClassValue }) => {
  const projectSettings: ProjectSettings = useProjSettings();
  const [learnMoreHTML, setLearnMoreHTML] = useState('');
  const warrantyJSON: string = projectSettings?.warrantyJSON ?? '';
  const defaultWarrantyLearnMoreTitle: string = projectSettings?.defaultWarrantyLearnMoreTitle ?? '';

  const learnMoreEntryTitle = useMemo(() => {
    try {
      const learnMoreJSON: Record<string, string> = JSON.parse(warrantyJSON || '{}');
      return (
        getMostSpecificMatch(learnMoreJSON, department, classValue, subClassValue) ?? defaultWarrantyLearnMoreTitle
      );
    } catch (e) {
      console.error('Error parsing warranty JSON:', e);
      return defaultWarrantyLearnMoreTitle;
    }
  }, [warrantyJSON, department, classValue, subClassValue, defaultWarrantyLearnMoreTitle]);

  useEffect(() => {
    if (!learnMoreEntryTitle) return;

    let isCancelled = false;

    getContentByTitle(learnMoreEntryTitle, false)
      .then((data: any) => {
        if (!isCancelled) {
          setLearnMoreHTML(data?.htmlCss_Script_Renderer_By_TitleEntries?.[0]?.html_css?.content || '');
        }
      })
      .catch((e) => {
        console.error('Error fetching learn more content:', e);
        if (!isCancelled) setLearnMoreHTML('');
      });

    return () => {
      isCancelled = true;
    };
  }, [learnMoreEntryTitle]);

  const transform = (node: any, index: any) => {
    if (index?.name === 'a' && index?.attribs?.class?.includes('faqLink')) {
      const href = getFAQLink(index?.attribs?.href);
      return (
        <a target="_blank" href={href} className="faqLink underline" rel="noreferrer">
          {domToReact(index?.children)}
        </a>
      );
    } else {
      return node;
    }
  };

  const reactElements: any = learnMoreHTML ? parse(learnMoreHTML, { transform }) : null;

  return (
    <Dialog>
      <DialogTrigger className="whitespace-nowrap font-medium underline">Learn More</DialogTrigger>
      <DialogContent className="customtablescrollbar h-[calc(100vh_-_48px)] w-[calc(100%_-_30px)] max-w-[400px] overflow-auto rounded-sm bg-white p-0 pb-10 md:max-w-[640px] ">
        <section>{reactElements}</section>
      </DialogContent>
    </Dialog>
  );
};

export default LearnMore;
